import { Link } from "react-router-dom";

const footerLinks = {
  navigation: [
    { label: "首页", href: "/" },
    { label: "社会热点", href: "/category/social" },
    { label: "娱乐八卦", href: "/category/entertainment" },
    { label: "科技资讯", href: "/category/tech" },
    { label: "关于我们", href: "/about" },
  ],
  social: [
    { label: "微博", href: "#", icon: "ri-weibo-line" },
    { label: "微信公众号", href: "#", icon: "ri-wechat-line" },
    { label: "知乎", href: "#", icon: "ri-zhihu-line" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 relative overflow-hidden rounded-t-2xl mt-16">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1 - Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-2xl font-black tracking-tight">
                51<span className="text-accent-500">黑料</span>网
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              真实爆料第一平台，专注社会热点、娱乐八卦、科技资讯，为您提供真实及时的独家爆料内容。
            </p>
          </div>

          {/* Col 2 - Navigation */}
          <div>
            <h4 className="font-heading text-base font-semibold mb-5">快速导航</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Social */}
          <div>
            <h4 className="font-heading text-base font-semibold mb-5">关注我们</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.social.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-foreground-300 hover:text-background-50 text-sm transition-colors flex items-center gap-2 cursor-pointer"
                    rel="nofollow"
                    target="_blank"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={item.icon}></i>
                    </span>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 - Subscribe */}
          <div>
            <h4 className="font-heading text-base font-semibold mb-3">订阅每日爆料</h4>
            <p className="text-foreground-300 text-sm mb-4">
              第一时间获取最新爆料推送
            </p>
            <form
              action="https://readdy.ai/api/form/d915g3q181e9e92u99eg"
              method="POST"
              data-readdy-form
              className="flex items-stretch gap-0"
            >
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="website-alt-field"
              />
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                className="flex-1 px-4 py-2.5 text-sm bg-foreground-800 border border-foreground-700 rounded-l-full text-background-50 placeholder:text-foreground-400 outline-none focus:border-primary-500 transition-colors"
                required
              />
              <button
                type="submit"
                className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-r-full transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom decorative brand text */}
      <div className="relative overflow-hidden pb-8">
        <p className="font-heading text-[120px] md:text-[180px] font-black text-foreground-800/20 leading-none text-center select-none">
          51黑料网
        </p>
      </div>

      {/* Copyright */}
      <div className="border-t border-foreground-800/50 px-4 md:px-6 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-foreground-400">
          <p>&copy; {new Date().getFullYear()} 51黑料网 版权所有</p>
          <p>真实爆料，尽在51黑料网</p>
        </div>
      </div>
    </footer>
  );
}